import { makeRouter } from '@adornis/router/client/make-router.js';
import { html } from 'lit';
import * as m from '../../../../localization/out/messages.js';
import { pageTitle } from '../../page-title.js';
import { CompanyApplicationDetail } from './company-application-detail.js';
import { CompanyJobDetail } from './company-job-detail.js';
import { CompanyJobEdit as CompanyJobEditPage } from './company-job-edit.js';
import { CompanyJobs } from './company-jobs.js';
import { CompanyProfile } from './company-profile.js';

export const companyJobRouter = makeRouter(
  {
    root: {
      path: '/:jobPositionID',
      documentTitlePart: pageTitle(m.page_title_job),
      render:
        ({ jobPositionID }) =>
        ({ companyID }) =>
          CompanyJobDetail({ companyID, jobPositionID: (jobPositionID ?? '') as string }),
    },
    edit: {
      path: '/:jobPositionID/edit',
      documentTitlePart: ({ jobPositionID }) =>
        pageTitle(jobPositionID === 'new' ? m.job_form_create_title : m.job_form_edit_title)(),
      render:
        ({ jobPositionID }) =>
        ({ companyID }) =>
          CompanyJobEditPage({ companyID, jobPositionID: (jobPositionID ?? '') as string }),
    },
  },
  {
    fallback: () => () => {
      return html` ${m.page_not_found()}`;
    },
  },
);

export const companyRouter = makeRouter(
  {
    root: {
      path: '/',
      documentTitlePart: pageTitle(m.company_jobs_title),
      render:
        () =>
        ({ companyID }) =>
          CompanyJobs({ companyID }),
    },
    companyProfile: {
      path: '/profile',
      documentTitlePart: pageTitle(m.company_profile_title),
      render:
        () =>
        ({ companyID }) => {
          return html` <div class="p-4 sm:p-8 flex flex-col items-center">${CompanyProfile({ companyID })}</div> `;
        },
    },
    jobDetail: {
      path: '/job{/*}*',
      documentTitlePart: '',
      subRouter: companyJobRouter,
      render:
        () =>
        ({ companyID }) =>
          companyJobRouter.outlet.value({ companyID }),
    },
    applicationDetail: {
      path: '/application/:applicationID',
      documentTitlePart: pageTitle(m.application_title),
      render:
        ({ applicationID }) =>
        () =>
          applicationID ? CompanyApplicationDetail({ applicationID }) : html`${m.page_not_found()}`,
    },
  },
  { fallback: () => html` ${m.page_not_found()}` },
);
